import React from "react";
import { Link } from "react-router-dom";
import FucaScoreLogo from "../../Assets/Images/fucascore_png.png";

const HomeFooter = ({ setMainTab }) => {
  return (
    <footer className="home-footer">
      <div className="footer-content">
        <div className="footer-section">
          <img src={FucaScoreLogo} alt="FucaScore logo" />
          <h3>FucaScore</h3>
          <p>Web aplikacija za malonogometne turnire</p>
        </div>

        <div className="footer-links">
          <Link to="/pokreni-turnir">Pokreni turnir</Link>
          <Link to="/politika-privatnosti">Politika privatnosti</Link>
          <Link to="/uvjeti-korištenja">Uvjeti korištenja</Link>
        </div>

        <div className="footer-social">
          <a
            href="https://www.instagram.com/fucascore/"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fi fi-brands-instagram"></i>
          </a>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} FucaScore. Web izradio Teo Ivanuš.
          </p>
        </div>
        <p className="footer-credits">
          Ikone:{" "}
          <a href="https://www.flaticon.com/" target="_blank" rel="noreferrer">
            Flaticon
          </a>
        </p>
      </div>
    </footer>
  );
};

export default HomeFooter;
